<template>
	<div id="app">
		<a-layout v-if="!isLoginPage" class="layout">
      <top-menu v-model="collapsed"></top-menu>

			<a-layout class="layout-content">
        <a-layout-sider v-model="collapsed" :trigger="null" collapsible class="layout-side">
          <left-menu></left-menu>
        </a-layout-sider>

        <a-layout-content
          :style="{
            margin: '0 0 8px 8px',
            padding: '24px',
            background: '#fff',
            display: 'flex',
            width: '800px',
            'border-radius': '0',
          }"
          :class="{ 'without-layout': withoutLayout }"
        >
          <router-view v-if="isRouterAlive"></router-view>
        </a-layout-content>
			</a-layout>
		</a-layout>

		<router-view v-else></router-view>
	</div>
</template>
<script>
import LeftMenu from "./components/left-menu";
import TopMenu from "./components/top-menu";

const WITH_OUT_LAYOUT_ROUTE_NAME = ["ReviewOrderDetail", "OrderDetail"];

export default {
	data() {
		return {
			collapsed: false,
			isRouterAlive: true,
		};
	},

	provide() {
		return {
			reload: this.reload,
		};
	},

	computed: {
		isLoginPage() {
			return this.$route.path === "/login";
		},

		withoutLayout() {
			return (
				WITH_OUT_LAYOUT_ROUTE_NAME.includes(this.$route.name)
			);
		},
	},

	components: {
		LeftMenu,
		TopMenu,
	},

	mounted() {},

	watch: {
		$route: {
			handler(newR, oldR) {
				if (newR.name == "OrderDetail" || newR.name == "ReviewOrderDetail") {
					document.querySelector(".ant-layout-content").scrollTo(0, 0);
				}
			},
		},
	},

	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}

.layout {
	background-color: rgba(242, 248, 252, 1);
}

.ant-layout {
	height: 100vh;
	overflow: hidden;
}

.layout-side {
	width: 207px;
	background-color: #FFFFFF;
	margin: 0 8px 8px 0;
}

.layout-content {
	background-color: rgba(242, 248, 252, 1);
}

.ant-layout-content {
	overflow-y: auto;
	border-radius: 24px;
}

.without-layout {
	background: transparent !important;
	overflow: hidden;
	padding: 12px 0 !important;
  margin-bottom: 0;
}
</style>
